/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { useHistory } from 'react-router-dom';
import { colors } from '_styles';

const Container = styled.div`
  width: 80%;
  margin: auto;
  padding: 20px;
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Btn = styled.button`
  position: relative;
  font-size: 14px !important;
   
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
`;

const Feedback = () => {
  const { replace, location } = useHistory();
  const { customConfirmationMessage } = location.state;

  const onClick = () => {
    replace('/help');
  };

  return (
    <Container>
      <div style={{ marginBottom: 40 }}>
        {parse(customConfirmationMessage)}
      </div>
      <BtnContainer>
        <Btn onClick={onClick}>
          Done
        </Btn>
      </BtnContainer>
    </Container>
  );
};

export default Feedback;
